import React, { useEffect } from 'react'; // eslint-disable-next-line
import { Row, Col, Card, CardBody, CardHeader, Button, Image } from 'react-bootstrap'; // eslint-disable-next-line
import qr_code from '../../assets/img/logos/qr_code.jpg'; // eslint-disable-next-line
import logo from '../../assets/img/illustrations/amity_logo.png';
import QRCode from 'react-qr-code'; //
const Footer = props => {
	const { pageLanguageContent, votingData } = props;
	useEffect(() => {
		// eslint-disable-next-line
	}, []);

	return (
		<div className='d-flex justify-content-between align-items-end'>
			<div className='qr-box'>
				<div className='image_area'>
					{votingData.qr_url ? (
						<QRCode value={votingData?.qr_url} size={85} alt={votingData?.qr_url} />
					) : (
						<Image src={qr_code} alt={qr_code} />
					)}
				</div>
				<span>{pageLanguageContent['VOT013'] ? pageLanguageContent['VOT013'] : ''}</span>
			</div>
			<div className='logo-text'>
				<Image src={logo} alt={logo} />
			</div>
		</div>
	);
};
export default Footer;
